import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadEmojiTitle } from '@confluence/emoji-title/entry-points/preloadEmojiTitle.ts';
import { preloadEditorPageCoverPicture } from '@confluence/page-cover-picture/entry-points/preloadEditorPageCoverPicture.ts';

import { SmartCreatePageEditorDataWrapperComponentQuery } from './SmartCreatePageEditorDataWrapperComponentQuery.graphql.ts';
import type {
	SmartCreatePageEditorDataWrapperComponentQuery as SmartCreatePageEditorDataWrapperComponentQueryType,
	SmartCreatePageEditorDataWrapperComponentQueryVariables,
} from './__types__/SmartCreatePageEditorDataWrapperComponentQuery.ts';

const preloadEditorData = async (contentId: string) => {
	return query<
		SmartCreatePageEditorDataWrapperComponentQueryType,
		SmartCreatePageEditorDataWrapperComponentQueryVariables
	>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: SmartCreatePageEditorDataWrapperComponentQuery,
		variables: {
			contentId,
		},
	});
};

export const preloadSmartCreateEditorData = async (contentId: string) => {
	return waitForAllReturnWhenError([
		preloadEditorData(contentId),
		preloadEmojiTitle(contentId, '', false),
		preloadEditorPageCoverPicture(contentId, '', false),
	]);
};
